import { render, staticRenderFns } from "./productDialog(old).vue?vue&type=template&id=78268a07&scoped=true&"
import script from "./productDialog(old).vue?vue&type=script&lang=js&"
export * from "./productDialog(old).vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78268a07",
  null
  
)

export default component.exports